exports.formatCurrency = (number) => {
  return new Intl.NumberFormat('en-US', { currency: 'USD', maximumFractionDigits: 2 }).format(number);
};

exports.roundToTwoDecimalPlaces = (number) => {
  return Math.round(number * 100) / 100;
};
